import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { authActions } from '@store/auth/auth.slice';

import { RouteEnum } from '@enum/route.enum';
import { useStoreDispatch } from '@hook/store/store.hooks';

export const useSignUp = () => {
  const dispatch = useStoreDispatch();
  const navigate = useNavigate();

  const onSignInPage = useCallback(() => {
    dispatch(authActions.resetErrors());
    navigate(RouteEnum.Login.path);
  }, [dispatch, navigate]);

  return { onSignInPage };
};
